module.exports = __webpack_public_path__ + "img/area_1.7aaccfe0.svg";